import { render } from "./BoardWebzine.vue?vue&type=template&id=083e9d7a"
import script from "./BoardWebzine.vue?vue&type=script&lang=js"
export * from "./BoardWebzine.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__